/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drab_Large_Chipmunk_EnjoyInputs */

const fr_drab_large_chipmunk_enjoy = /** @type {(inputs: Drab_Large_Chipmunk_EnjoyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**

* @param {Drab_Large_Chipmunk_EnjoyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const drab_large_chipmunk_enjoy = /** @type {((inputs?: Drab_Large_Chipmunk_EnjoyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drab_Large_Chipmunk_EnjoyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_drab_large_chipmunk_enjoy(inputs)
});